/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WordsRouteImport } from './routes/words'
import { Route as LoginRouteImport } from './routes/login'
import { Route as WordsIndexRouteImport } from './routes/words.index'
import { Route as WordsSettingsRouteImport } from './routes/words.settings'
import { Route as WordsBulkAddRouteImport } from './routes/words.bulk-add'
import { Route as WordsWordIdRouteImport } from './routes/words.$wordId'

const WordsRoute = WordsRouteImport.update({
  id: '/words',
  path: '/words',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const WordsIndexRoute = WordsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WordsRoute,
} as any)
const WordsSettingsRoute = WordsSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => WordsRoute,
} as any)
const WordsBulkAddRoute = WordsBulkAddRouteImport.update({
  id: '/bulk-add',
  path: '/bulk-add',
  getParentRoute: () => WordsRoute,
} as any)
const WordsWordIdRoute = WordsWordIdRouteImport.update({
  id: '/$wordId',
  path: '/$wordId',
  getParentRoute: () => WordsRoute,
} as any)

export interface FileRoutesByFullPath {
  '/login': typeof LoginRoute
  '/words': typeof WordsRouteWithChildren
  '/words/$wordId': typeof WordsWordIdRoute
  '/words/bulk-add': typeof WordsBulkAddRoute
  '/words/settings': typeof WordsSettingsRoute
  '/words/': typeof WordsIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/words/$wordId': typeof WordsWordIdRoute
  '/words/bulk-add': typeof WordsBulkAddRoute
  '/words/settings': typeof WordsSettingsRoute
  '/words': typeof WordsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/login': typeof LoginRoute
  '/words': typeof WordsRouteWithChildren
  '/words/$wordId': typeof WordsWordIdRoute
  '/words/bulk-add': typeof WordsBulkAddRoute
  '/words/settings': typeof WordsSettingsRoute
  '/words/': typeof WordsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/login'
    | '/words'
    | '/words/$wordId'
    | '/words/bulk-add'
    | '/words/settings'
    | '/words/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/words/$wordId'
    | '/words/bulk-add'
    | '/words/settings'
    | '/words'
  id:
    | '__root__'
    | '/login'
    | '/words'
    | '/words/$wordId'
    | '/words/bulk-add'
    | '/words/settings'
    | '/words/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  LoginRoute: typeof LoginRoute
  WordsRoute: typeof WordsRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/words': {
      id: '/words'
      path: '/words'
      fullPath: '/words'
      preLoaderRoute: typeof WordsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/words/': {
      id: '/words/'
      path: '/'
      fullPath: '/words/'
      preLoaderRoute: typeof WordsIndexRouteImport
      parentRoute: typeof WordsRoute
    }
    '/words/settings': {
      id: '/words/settings'
      path: '/settings'
      fullPath: '/words/settings'
      preLoaderRoute: typeof WordsSettingsRouteImport
      parentRoute: typeof WordsRoute
    }
    '/words/bulk-add': {
      id: '/words/bulk-add'
      path: '/bulk-add'
      fullPath: '/words/bulk-add'
      preLoaderRoute: typeof WordsBulkAddRouteImport
      parentRoute: typeof WordsRoute
    }
    '/words/$wordId': {
      id: '/words/$wordId'
      path: '/$wordId'
      fullPath: '/words/$wordId'
      preLoaderRoute: typeof WordsWordIdRouteImport
      parentRoute: typeof WordsRoute
    }
  }
}

interface WordsRouteChildren {
  WordsWordIdRoute: typeof WordsWordIdRoute
  WordsBulkAddRoute: typeof WordsBulkAddRoute
  WordsSettingsRoute: typeof WordsSettingsRoute
  WordsIndexRoute: typeof WordsIndexRoute
}

const WordsRouteChildren: WordsRouteChildren = {
  WordsWordIdRoute: WordsWordIdRoute,
  WordsBulkAddRoute: WordsBulkAddRoute,
  WordsSettingsRoute: WordsSettingsRoute,
  WordsIndexRoute: WordsIndexRoute,
}

const WordsRouteWithChildren = WordsRoute._addFileChildren(WordsRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  LoginRoute: LoginRoute,
  WordsRoute: WordsRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
